import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import useAuthStore from "../components/stores/useAuthStore";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import UserService from "../services/UserService";

const Login = () => {
  const { login, isLoggedIn } = useAuthStore((state) => state);

  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [showhideTickIcon, setShowhideTickIcon] = useState("d-none");
  const [showPassword, setshowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [display, setDisplay] = useState(false);

  const handleSubmit = async (_e) => {
    try {
      _e.preventDefault();
      const res = await UserService.authenticate(email, password);
      if (!!res?.token) {
        login(res.token);
      }
    } catch (error) {
      setDisplay(true);
      setMessage("Email ou mot de passe invalide.");
    }
  };

  const handleClose = () => {
    setDisplay(false);
    setMessage("");
  };

  const handlerShowPassword = () => setshowPassword(!showPassword);

  useEffect(() => {
    if (!!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn]);

  return (
    <StyleWrapper>
      <div className="d-flex justify-content-center">
        <div className="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
          <div className="login-form-container">
            <div className="col-12">
              <div className="img-container mb-4 pb-3">
                <img src="/assets/icons/smart-doc.svg" alt="Logo" />
              </div>
              <div className="text-center mb-4 pb-2">
                <span className="login-title">Login</span>
              </div>
              {display && (
                <div className="alert alert-danger d-flex justify-content-between align-items-center ">
                  <p className="mb-0 text-danger">{message}</p>
                  <IconButton
                    className="close-btn"
                    aria-label="Fermer"
                    onClick={handleClose}
                    disableRipple
                  >
                    <CloseIcon className="text-danger" />
                  </IconButton>
                </div>
              )}
              <div className="form-group mb-3 pb-1 position-relative">
                <label
                  htmlFor="userEmail"
                  className="col-sm-12 form-group-label"
                >
                  Email<span>*</span>
                </label>
                <div className="col-sm-12 position-relative">
                  <input
                    type="email"
                    id="userEmail"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    // onFocus={resetErrorFieldStyle}
                    // onChange={changeHandlerLoginField}
                  />
                  <img
                    src="/assets/icons/tick.svg"
                    className={`input-field-icons ` + showhideTickIcon}
                    alt="tick vector"
                  />
                </div>
                <small className="text-danger position-absolute fs-small login-field-error">
                  {emailMessage}
                </small>
              </div>

              <div className="form-group mb-3 pb-1 position-relative">
                <label
                  htmlFor="password"
                  className="col-sm-12 form-group-label"
                >
                  Password<span>*</span>
                </label>
                <div className="col-sm-12 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="userPassword"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    // onFocus={resetErrorFieldStyle}
                    // onKeyPress={handleEnter}
                  />
                  <img
                    src={
                      showPassword
                        ? "/assets/icons/eye-open.svg"
                        : "/assets/icons/eye-off.svg"
                    }
                    className="input-field-icons eye-icon"
                    alt="eye vector"
                    onClick={handlerShowPassword}
                  />
                </div>
                <small className="text-danger position-absolute fs-small login-field-error">
                  {passwordMessage}
                </small>
              </div>
              <div className="form-check mb-3 pb-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="checkRemember"
                />
                <label className="form-check-label" htmlFor="checkRemember">
                  Remember Me
                </label>
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="site-btn site-btn-padd w-100"
                  onClick={handleSubmit}
                >
                  Login
                </button>
              </div>
              <div className="text-center mt-3 pt-1">
                <p className="forgot-pwd">
                  Forgot password?
                  <a href="mailto:Info@mindfree.be" className="create-account">
                    Contact Us
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="text-center">
            <p className="rights-text">
              © {new Date().getFullYear()} Smart Doc . Alright reserved.
              <a className="login-bottom-links ms-2">Terms & Conditions</a>
              <a className="login-bottom-links ms-2">Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  .login-message-box {
    padding: 15px;
  }

  .alert {
    padding: 5px 10px;
  }

  .login-message-box * {
    font-family: var(--manrope);
    font-size: 14px;
  }

  .login-error-box {
    background-color: rgba(224, 49, 55, 0.2);
    color: black;
  }

  .login-form-container {
    margin-top: 3rem;
    box-shadow: 0px 14px 44px 0px #00000005;
    background-color: #ffffff;
    padding: 30px 30px 20px 30px;
    border-radius: var(--radius);
  }

  .img-container {
    text-align: center;

    img {
      width: 214px;
    }
  }

  .login-title {
    font-family: var(--manrope);
    font-size: 24px;
    font-weight: 700;
    line-height: 31.2px;
    text-align: center;
  }

  .login-field-error {
    font-family: var(--manrope);
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
    margin-top: 2px;
    letter-spacing: 0.6px;
  }

  .input-field-icons {
    position: absolute;
    top: calc(100% / 3);
    right: 20px;
  }

  .site-btn {
    background: var(--blue);
    border-radius: 10px;
    color: var(--white);
    font-family: var(--manrope);
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.3px;
    text-align: center;
    border: none;
    padding: 6px 18px;

    &:hover {
      color: var(--white);
      background-color: var(--blue);
    }
  }

  .forgot-pwd {
    font-family: var(--manrope);
    font-size: 14px;
    font-weight: 500;
    line-height: 22.4px;
    text-align: center;
    color: var(--light-grey-text);
  }

  .create-account {
    color: var(--red-color);
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.20000000298023224px;
    text-align: left;
    font-family: var(--manrope);
    margin-left: 5px;
    text-decoration: none;
  }

  .rights-text {
    font-family: var(--manrope);
    font-size: 14px;
    font-weight: 500;
    line-height: 22.4px;
    color: var(--menu-link-color);
    margin-top: 1rem;
  }

  .login-bottom-links {
    color: var(--text-color);
    text-decoration: none;
  }

  .form-check-input:checked {
    background-color: var(--red-color);
    border-color: var(--red-color);
  }
`;

export default Login;
